export default "__VITE_ASSET__BkAWIhcC__"